"use client";

import React, { useEffect, useState } from "react";

export default function ExternalBrowser({ links, child }) {
  const [isWebView, setIsWebView] = useState(false);
  const link = links;
  const fallBackLink = links;
  useEffect(() => {
    if (typeof window !== "undefined") {
      const userAgent = navigator.userAgent || navigator.vendor || window.opera;

      // List of common webview identifiers
      const webViewIdentifiers = [
        "FBAN", // Facebook app
        "FBAV", // Facebook app
        "Instagram", // Instagram app
        // "Twitter", // Twitter app
        // "Line", // LINE app
        "Messenger", // Facebook Messenger
        // "WebView", // Generic WebView
        // "wv", // Generic WebView on Android
        // "Android.*Version/.+Chrome/[.0-9]* Mobile Safari/[.0-9]*", // Chrome on Android
        // "iPhone", // iOS
        // "iPad", // iOS
        // "Telegram", // Telegram WebView
      ];

      const isWebView = webViewIdentifiers.some((identifier) =>
        new RegExp(identifier, "i").test(userAgent)
      );
      // setIsWebView((_prev) => {
      //   openInExternalBrowser(isWebView);
      //   return isWebView;
      // });
    }
  }, []);
  return <main>{child}</main>;
}
